export default __webpack_public_path__ + "static/media/zoom_out.49314419.svg";